export const MENU_OPTIONS = [
  {
    value: "Classic Honey Cake (MEDOVIK)",
    label: "Classic Honey Cake (MEDOVIK)",
  },
  {
    value: "Honey Cake with Caramel & Nuts",
    label: "Honey Cake with Caramel & Nuts",
  },
  {
    value: "Pistachio & Raspberry Honey Cake",
    label: "Pistachio & Raspberry Honey Cake",
  },
  { value: "Classic Tres Leches", label: "Classic Tres Leches" },
  { value: "Key Lime Tres Leches", label: "Key Lime Tres Leches" },
  {
    value: "Strawberry & Lemon Tres Leches",
    label: "Strawberry & Lemon Tres Leches",
  },
  { value: "Tropical Tres Leches", label: "Tropical Tres Leches" },
  {
    value: "Meringue Roll Pistachio & Raspberry",
    label: "Meringue Roll Pistachio & Raspberry",
  },
  {
    value: "Meringue Roll Pecan & Coffee",
    label: "Meringue Roll Pecan & Coffee",
  },
  {
    value: "Meringue Roll Mango-Passion Fruit & Coconut",
    label: "Meringue Roll Mango-Passion Fruit & Coconut",
  },
  {
    value: "Meringue Roll Strawberry & Lemon",
    label: "Meringue Roll Strawberry & Lemon",
  },
  {
    value: "Meringue Roll Peach (Pear) & Blue Cheese",
    label: "Meringue Roll Peach (Pear) & Blue Cheese",
  },
  { value: "Carrot Cake", label: "Carrot Cake" },
  {
    value: "Three Chocolate Mousse Cake",
    label: "Three Chocolate Mousse Cake",
  },
  {
    value: "Mille-Feuille (NAPOLEON) Cake",
    label: "Mille-Feuille (NAPOLEON) Cake",
  },
  {
    value: "Signature Cakes",
    label: "Signature Cakes",
  },
] as const;
